import { Injectable } from '@angular/core';
import APP_CONFIG from '../../../app-config/app-config';

declare const window;
if(APP_CONFIG.is_electron) {
	var electron = window.require('electron');
}

@Injectable() 
export class ElectronProvider {
	constructor() {

	}

	openExternalLink(link) {
		electron.shell.openExternal(link);
	}
}


// WEBPACK FOOTER //
// ./src/providers/electron/electron.ts